angular.module('unergie.main')
.filter('isLinky', (PrmUtilsService) => PrmUtilsService.isLinky)
